module.exports = __webpack_public_path__ + "static/media/19ESCAP50.6e14d0a8.jpg";